import { NgxCookiebotConfig } from '@halloverden/ngx-cookiebot';

export class CookiebotConfig extends NgxCookiebotConfig {
  override blockingMode: string = 'manual';
  override cbId: string = '15c34404-cc8d-41a9-9e28-f0b67433bc7e';
  override cdn: string = 'com';
  override loadScript: boolean = true;
}
